import { Component, Inject, OnInit, ViewContainerRef, DOCUMENT } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { GoogleTagManagerService } from 'angular-google-tag-manager';
import {environment} from '../environments/environment';
import { AmplifyAuthenticatorModule, AuthenticatorService} from '@aws-amplify/ui-angular';
import { SettingsService } from './configuration/settings.service';
import { ConfigurationService } from './configuration/configuration.service';
import { Subscription } from 'rxjs';
import { SecurityService } from './security/security.service';
import { PopupInfoService } from './shared/components/map-viewer/services/popup-info.service';
import { signIn } from 'aws-amplify/auth';
import { ToastService } from './shared/services/toast.service';
import { RootRoute } from './shared/models/angular-routing';
import { MaterialModule } from './shared/material/material.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [AmplifyAuthenticatorModule, RouterOutlet, MaterialModule],
})
export class AppComponent implements OnInit {
  public formFields = {
    signIn: {
      username: {
        placeholder: 'Enter Your Email Here',
        isRequired: true,
        label: '',
        labelHidden: true,
      },
      password: {
        placeholder: 'Enter Your Password Here',
        isRequired: true,
        label: '',
        labelHidden: true,
        autocomplete: 'current-password',
      },
    },
  };

  configurationSubscription: Subscription;
  services: any;

  constructor(
    private router: Router,
    private gtmService: GoogleTagManagerService,
    public authenticator: AuthenticatorService,
    private settingsService: SettingsService,
    private securityService: SecurityService,
    private configurationService: ConfigurationService,
    private vcr: ViewContainerRef,
    private mapPopupService: PopupInfoService,
    @Inject(DOCUMENT) private document: HTMLDocument,
    public toastService: ToastService
  ) {
    this.mapPopupService.viewContainerRef = this.vcr;
    if (environment.name !== 'local') {
      this.router.events.subscribe(val => {
        // report page view events to Google Tag Manager
        if (val instanceof NavigationEnd) {
          const gtmTag = {
            event: 'page',
            pageName: val.url,
          };
          this.gtmService.pushTag(gtmTag);
        }
      });
    }

    // https://ui.docs.amplify.aws/angular/connected-components/authenticator/customization#override-function-calls
    this.services = {
      /*async handleSignIn(input: SignInInput) {
        return new Promise(async (resolve, reject) => {
          try {
            const output = await signIn(input);
            resolve(output);
          } catch (error) {
            // @ts-ignore
            console.log(error?.name);
            // @ts-ignore
            console.log(error?.message);
            // @ts-ignore
            if (error?.name === 'NotAuthorizedException') {
              toastService.long('Invalid credentials');
              authenticator.toForgotPassword();
            }
            reject(error);
          }
        });
      },*/
    };

    window.addEventListener('message', event => {
      if (event.origin !== environment.adminBaseUrl.replace(/\/$/, '')) {
        // eslint-disable-next-line no-console
        console.log('Invalid origin. Skipping auto-login.');
        return;
      }
      if (event.data?.type === 'AUTO_LOGIN') {
        const { username, password } = event.data;
        this.loginWithAmplify(username, password);
      }
    });
  }

  ngOnInit(): void {
    if (environment.name !== 'prod') {
      this.updateAppIcon(environment.name);
    }

    this.authenticator.subscribe(authenticator => {
      if (authenticator.authStatus === 'authenticated') {
        this.loadGeneralConfiguration();
        this.securityService.getUserEmail().then(email => {
          window.document.title = `PlowOps - ${email}`;
        });
      } else if (authenticator.authStatus === 'unauthenticated') {
        this.configurationSubscription?.unsubscribe();
        this.configurationSubscription = undefined;
        window.document.title = 'PlowOps Dashboard';
      }
    });
  }

  async loginWithAmplify(username: string, password: string) {
    try {
      await signIn({ username, password });
      window.location.href = `/${RootRoute.MAIN}`;
    } catch (err) {
      const errorMessage = `Login failed! ${err}`;
      console.error('Login failed', errorMessage);
      this.toastService.long(errorMessage);
    }
  }

  private updateAppIcon(env: string) {
    const iconLink = this.document.getElementById('appIcon');
    iconLink.setAttribute('type', 'image/png');
    iconLink.setAttribute('href', `assets/plowops_logo_${env}_round.png`);
  }

  getLoginLogoUrl() {
    return `${environment.publicBaseUrl}plowops_logo_small.png`;
  }

  goTo(url: string) {
    window.open(url, '_blank');
  }

  private loadGeneralConfiguration() {
    this.configurationService.refreshConfiguration();
    this.configurationService.refreshTrackStyles();
    this.configurationSubscription = this.configurationService.sharedConfigurationModel.subscribe(model => {
      if (model) {
        this.settingsService.initSettings(model);
        this.configurationService.initUserTrackStyles();
      }
    });
  }
}
